module.exports = __webpack_public_path__ + "media/images/flags/32/Finland-cd5550bac011f8913e8a3f560020cd57.png";